import { memo, useCallback } from 'react'

import { Divider, SvgIcon } from '@mui/material'
import { OrgEnvironmentRoleRamInvitation } from '@nativewaves/nw-cloud-sdk/org'
import { PlugDisconnected } from 'emotion-icons/fluentui-system-filled'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { MenuItemConfirm, MenuItemCopyId } from '@shared/components/MaterialUIEnhancements/Menu/MenuItem'
import { RowActionsProps } from '@shared/components/Table'
import { useEnvironmentInvitationDeleteMutation } from 'hooks/mutations/org'
import { invitationsOverviewRoute } from 'pages/NWPlatform/Environment'

const RowActionsRaw = ({ row, onClose }: RowActionsProps<OrgEnvironmentRoleRamInvitation>) => {
  const { t } = useTranslation(['common', 'entity', 'domain'])
  const { enqueueSnackbar } = useSnackbar()

  const { environmentId } = invitationsOverviewRoute.useParams()

  const { id, recipientEmail } = row.original

  const { mutate: cancelInvitation } = useEnvironmentInvitationDeleteMutation()

  const handleDeleteMember = useCallback(() => {
    onClose()

    cancelInvitation(
      { environmentId, invitationId: id },
      {
        onError: () =>
          enqueueSnackbar(t('success.entityDelete', { entity: recipientEmail }), {
            variant: 'error',
          }),
      },
    )
  }, [onClose, cancelInvitation, environmentId, id, enqueueSnackbar, t, recipientEmail])

  return (
    <>
      <MenuItemCopyId onSuccess={onClose} id={id} />
      <Divider sx={{ my: 1 }} component="li" />
      <MenuItemConfirm
        onConfirm={handleDeleteMember}
        staticLabel={t('domain:EnvironmentSetting.removeInvitation')}
        startIcon={
          <SvgIcon color="error">
            <PlugDisconnected />
          </SvgIcon>
        }
        ConfirmTypographyProps={{ color: 'error' }}
      />
    </>
  )
}

export const RowActions = memo(RowActionsRaw)
